import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { toast } from '../hooks/use-toast';

const AuthDialog = ({ open, onOpenChange, mode = 'signin', onSwitch }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const isSignUp = mode === 'signup';

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast({ title: 'Missing fields', description: 'Please fill email and password.' });
      return;
    }
    toast({
      title: isSignUp ? 'Account created' : 'Welcome back',
      description: `Signed ${isSignUp ? 'up' : 'in'} as ${email}`,
    });
    onOpenChange(false);
    setEmail('');
    setPassword('');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl tracking-tight">
            {isSignUp ? 'Create your account' : 'Sign in to Delos'}
          </DialogTitle>
          <DialogDescription>
            {isSignUp ? 'Start hiring AI workers in seconds.' : 'Welcome back — pick up where you left off.'}
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Work email</Label>
            <Input
              id="email"
              type="email"
              placeholder="you@company.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <Button type="submit" className="w-full bg-neutral-900 text-white hover:bg-neutral-800">
            {isSignUp ? 'Create account' : 'Sign in'}
          </Button>
        </form>

        <div className="relative my-2">
          <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-neutral-200" /></div>
          <div className="relative flex justify-center"><span className="bg-white px-3 text-xs text-neutral-400">OR</span></div>
        </div>

        <Button variant="outline" className="w-full border-neutral-300 bg-white text-neutral-800 hover:bg-neutral-50">
          Continue with Google
        </Button>

        <p className="pt-2 text-center text-sm text-neutral-500">
          {isSignUp ? 'Already have an account?' : "Don't have an account?"}{' '}
          <button
            type="button"
            onClick={() => onSwitch?.(isSignUp ? 'signin' : 'signup')}
            className="font-medium text-neutral-900 underline underline-offset-2"
          >
            {isSignUp ? 'Sign in' : 'Sign up'}
          </button>
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default AuthDialog;
